import { GoalCategory } from './goal-category';
import { GoalType } from './goal-type';

export class Goal {
    public GoalId:string;

    public Name:string;

    public Description:string;

    public GoalCategoryId:string;

    public GoalCategory:GoalCategory;

    public GoalTypeId:number;

    public GoalType:GoalType;

    public IsSystemGenerated:boolean;

    public ShouldShowGrid:boolean;

    public ShouldShowChart:boolean;

    public ShouldShowMemberCount:boolean;
    
    public ShouldShowPerCapita:boolean;

    public ShouldShowAllTimeHigh:boolean;

    public ShouldShowFiveYearHigh:boolean;

    public ShouldShowPercentage:boolean;

    public NumYearsHistoricalData:number;

    public SortOrder:number;

    public StartDate:string;

    public EndDate:string;

    public IsDeleted:boolean;

    //MCM-1356 Added to display goal on new Citation tab
    public ShouldShowCitation: boolean;

    public CitationSortOrder: number;
    
    public ShouldPriorityGoals: boolean;

    constructor(GoalId:string = "", Name:string = ""){
        this.GoalId = GoalId;
        this.Name = Name;
    }

    //public GoalType:GoalType;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/goal.ts